module.exports = __webpack_public_path__ + "static/media/dev-exam-mobile.9af1a3e4.png";